<template>
  <div>
    <!-- desktop -->
    <div class="hidden place-content-center py-s200 m_1000:grid">
      <div class="loader"></div>
    </div>

    <!-- mobile -->
    <div class="grid place-content-center fixed top-0 right-0 z-70 w-full m_1000:hidden" style="min-height: var( --app-height);">
      <div class="bg-black/70 cursor-pointer absolute top-0 left-0 w-full h-full js_close_side_cart"></div>
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CategoryLoader",
  }
</script>